import _ from 'lodash';
import { TextAbbreviationDocument, TextAbbreviationPartArray, TextAbbreviationsMap } from 'models';
import { cleanUpText } from 'utils/html';

function partsToHtml(parts: TextAbbreviationPartArray): string {
  return parts.map((part) => {
    if (_.isObject(part)) {
      const { _: text, script } = part;

      const sanitizedText = cleanUpText(text);
      if (script === 'sub') {
        return `<sub>${sanitizedText}</sub>`;
      }

      if (script === 'sup') {
        return `<sup>${sanitizedText}</sup>`;
      }

      return sanitizedText;
    }

    return part;
  }).join('');
}

export function transformAbbreviationTermsToHTML(data: TextAbbreviationsMap): TextAbbreviationsMap {
  const result = _.cloneDeep(data);

  Object.keys(result).forEach((key) => {
    const doc: TextAbbreviationDocument = result[key];
    const term = doc?.abbreviation?.term;
    let termParts = _.isObject(term) ? term.part : undefined;

    if (!termParts) {
      return;
    }

    if (!_.isArray(termParts)) {
      termParts = [termParts];
    }

    doc.abbreviation.term = partsToHtml(termParts);
  });

  return result;
}
